Alpine.data('whatWereDoingParent', () => ({
	showing: 0,

	init() {
		// Listen to when the hash changes (this happens if the user clicks another section from the same page).
		// e.g. on the 'Our Work' page, when a user clicks 'Ending Cruelty', followed by 'For a Kinder World' links.
		window.addEventListener(
			'hashchange',
			() => {
				this.setInitialState();
			},
			false
		);

		setTimeout(() => {
			this.setInitialState();
		}, 100);
	},
	setInitialState() {
		const hash = window.location.hash;

		if (!hash) return;

		const triggerSelector = `${hash}-trigger`;
		const trigger = this.$root.querySelector(triggerSelector);

		if (trigger) {
			const index = parseInt(trigger.getAttribute('data-index'), 10);

			typeof index === 'number' &&
				!Number.isNaN(index) &&
				this.setShowing(index);
		}

		this.$nextTick(() => {
			window.scrollTo(0, 0);
		});
	},
	setShowing(index) {
		this.showing = index;
	},
	isShowing(index) {
		return index === this.showing;
	},
}));
